// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>9</span>&nbsp;&nbsp;For one day in your courts&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;is better than a thousand.<br> </p> </div></div>";
// Exports
module.exports = code;